/* tslint:disable */
/* eslint-disable */
/**
 * Payment API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/* tslint:disable */
/* eslint-disable */

/**
* このファイルは自動生成されています。そのためgit管理には含まれません。手動で編集してもdeploy時反映されません。
*/

/**
 * 承認ステータス
 * @export
 * @enum {number}
 */
export enum ApprovalStatusEnum {
    /** 未承認 */
    PENDING = 0,
    /** 承認済み */
    APPROVED = 1
}

/**
 * 承認ステータス の Union 型
 * @export
 * @typedef ApprovalStatus
 */
export type ApprovalStatus =
  typeof ApprovalStatusEnum[keyof typeof ApprovalStatusEnum];

/**
 * 承認ステータス のラベルマップ
 * @export
 */
export const ApprovalStatusLabels = {
    /**
     * 数値キー: ApprovalStatusEnum.PENDING
     * 名前キー:  PENDING
     */
    [ApprovalStatusEnum.PENDING]: '未承認',
    PENDING:                             '未承認',
    /**
     * 数値キー: ApprovalStatusEnum.APPROVED
     * 名前キー:  APPROVED
     */
    [ApprovalStatusEnum.APPROVED]: '承認済み',
    APPROVED:                             '承認済み',
} as const;

/**
 * 承認ステータス のラベル Union 型
 * @export
 * @typedef ApprovalStatusLabel
 */
export type ApprovalStatusLabel =
  typeof ApprovalStatusLabels[keyof typeof ApprovalStatusLabels];

/**
 * 承認ステータス のラベル取得関数
 * @export
 * @param { ApprovalStatus } value - 列挙体の値
 * @returns { ApprovalStatusLabel } ラベル文字列
 */
export function getApprovalStatusLabel(
  value: ApprovalStatus
): ApprovalStatusLabel {
  return ApprovalStatusLabels[value];
}

/**
 * 承認ステータス のラベル配列を取得する関数
 * @export
 * @param { ApprovalStatus[] } values - 列挙体の値配列
 * @returns { ApprovalStatusLabel[] } ラベル文字列配列
 */
export function getApprovalStatusLabels(values: ApprovalStatus[]): ApprovalStatusLabel[] {
  return values.map((value) => getApprovalStatusLabel(value));
}

/**
 * 承認ステータス のラベル配列
 * @export
 */
export const ApprovalStatusLabelList = [
  '未承認','承認済み',
] as const;

